import http from "@/settings/apiSettings"

class CrmCampaniiMarketingDataService {
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_CautareCampaniiMarketing", data);
  }

  update(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/CRM_CautareCampaniiMarketing(${key})`, data);
  }

  getById(key: string, expand = ''): Promise<any> {
    return http.clientComercialOdata.get(`/CRM_CautareCampaniiMarketing(${key})?${expand}`);
  }

  launchCampaign(key: string): Promise<any> {
    return http.clientComercialOdata.post(`/CRM_CautareCampaniiMarketing(${key})/LanseazaTrimitere`, {});
  }

}
export default new CrmCampaniiMarketingDataService();